module.exports = __webpack_public_path__ + "static/DEV6-ce2223546cc549b4336c7f29f87a388b.jpg";